export default __webpack_public_path__ + "static/media/logo-faint.59c5da94.svg";